var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownIconBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30026 4.3L0.700256 1.7C0.383589 1.38333 0.312923 1.021 0.488256 0.613C0.662923 0.204333 0.975257 0 1.42526 0H6.57526C7.02526 0 7.33759 0.204333 7.51226 0.613C7.68759 1.021 7.61692 1.38333 7.30026 1.7L4.70026 4.3C4.60026 4.4 4.49192 4.475 4.37526 4.525C4.25859 4.575 4.13359 4.6 4.00026 4.6C3.86692 4.6 3.74192 4.575 3.62526 4.525C3.50859 4.475 3.40026 4.4 3.30026 4.3Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIconBold);
export default __webpack_public_path__ + "static/media/down-icon-bold.2458df16209115390b633f8b1a71d414.svg";
export { ForwardRef as ReactComponent };